import { BankDealProfile, MilestoneReport } from '.';
import { StructureTranches, Tier1BankTypes, Tier3ContactTypes } from './TrancheEvaluation';

export interface ActiveDataRoomUser {
	id: number;
	guid: string;
	bankDealProfileGuid: string;
	bankContactGuid: string;
	fullName: string;
	bankName: string;
}

export interface ActiveDataRoomLender {
	dataRoomUserId: number;
	dataRoomUserGuid: string;
	bankDealProfileGuid: string;
	bankContactGuid: string;
	bankGuid: string;
	dataRoomGuid: string;
	dealGuid: string;
	fullName: string;
	bankName: string;
	emailAddress: string;
	hasTermSheets: boolean;
}

export interface DataRoomUser {
	id: number;
	guid: string;

	dataRoomId: number;
	bankDealProfileId: number;
	bankId: number;
	personId: number;
	userId: number;

	dataRoomGuid: string;
	bankDealProfileGuid: string;
	bankGuid: string;
	userGuid: string;

	bankName: string;
	firstName: string;
	lastName: string;
	emailAddress: string;
	phone: string;
	tier3ContactType: Tier3ContactTypes;
	tier3ContactTypeDescription: string;

	lenderScore?: number;
	lenderScoreLastUpdatedDate?: Date;
	isLockedOut: boolean;
	structureTranche?: StructureTranches;
	tier1?: Tier1BankTypes;

	lastAccessedOn?: Date;
	lastInviteSent?: Date;
	accessed: boolean;
	signedNda: boolean;
	allowAccess?: boolean;
	teamMemberCount: number;
	hasNda: boolean;
	optedOut: boolean;
	dealBankStatus: string;
	customNdaFileName: string;
	noteCount: number;

	readyForCall?: MilestoneStatusResponses | null;
	readyForCallOn?: Date | null;
	underwriting?: MilestoneStatusResponses | null;
	underwritingOn?: Date | null;
	parentDataRoomUserId: number | null;
	parentDataRoomUserGuid: string | null;
	isAssociatedContact: boolean;
	hasEnterpriseLoanWatchSubscription: boolean;
	bankDealProfile?: BankDealProfile;
	lenderScoreFlag: boolean;
	teamMembers: AssociatedTeamMember[];
}

export interface AssociatedTeamMember {
	id: number;
	guid: string;
	bankContactGuid: string;
	bankGuid: string;
	userGuid: string;
	bankName: string;
	firstName: string;
	lastName: string;
	emailAddress: string;
	phone: string;
	allowAccess: boolean;
	lastAccessedOn?: Date;
	contactType: AssociatedContactType;
	isLockedOut: boolean;
	parentDataRoomUserGuid: string | null;
}

export type AssociatedContactType = keyof typeof AssociatedContactTypeMap;
export const AssociatedContactTypeMap = {
	DataRoomUser: 'Data Room User',
	TeamMember: 'Team Member',
};

export type MilestoneStatusResponses = keyof typeof MilestoneStatusResponsesMap;
export const MilestoneStatusResponsesMap = {
	NotAnswered: 'Not Answered',
	Yes: 'Yes',
	OptOut: 'Out-Out',
	NotYet: 'Not Yet',
};

export interface DataRoomTeamMember {
	id: number;
	guid: string;

	bankContactTeamMemberId: number;
	bankContactId: number;
	bankId: number;
	personId: number;
	userId: number;
	dataRoomId: number;

	bankContactTeamMemberGuid: string;
	dataRoomGuid: string;
	bankContactGuid: string;
	bankGuid: string;
	userGuid: string;

	bankName: string;
	firstName: string;
	lastName: string;
	emailAddress: string;
	phone: string;

	allowAccess: boolean;
	lastAccessedOn?: Date;
	lastInviteSent?: Date;
	createdOn?: Date;

	dealStatus: string;
	isLockedOut: boolean;
}

export interface DataRoomContact {
	id: number;
	guid: string;

	personId: number;
	userId: number;
	dataRoomId: number;

	dataRoomGuid: string;
	userGuid: string;
	companyContactDataRoomGuid: string;

	bankName: string;
	firstName: string;
	lastName: string;
	emailAddress: string;
	phone: string;

	allowAccess: boolean;
	lastAccessedOn?: Date;
	lastInviteSent?: Date;
	createdOn?: Date;

	isLockedOut: boolean;
	isDealAdmin: boolean;
}

export interface SendInviteModel {
	subject: string;
	emailBody: string;
}

export interface DataRoomLenderStatusBar {
	roomUser: ActiveDataRoomUser;
	report: MilestoneReport;
}
